import { render, staticRenderFns } from "./PackagePricing.vue?vue&type=template&id=b8a4155e"
import script from "./PackagePricing.vue?vue&type=script&lang=js"
export * from "./PackagePricing.vue?vue&type=script&lang=js"
import style0 from "./PackagePricing.vue?vue&type=style&index=0&id=b8a4155e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports